'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _lodash = require('lodash');

var _components = require('../../components');

var _Companies = require('./Companies.css');

var _Companies2 = _interopRequireDefault(_Companies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompanySectors = require('../../data/CompanySectors.json');
var CompanyLinks = require('../../data/CompanyLinks.json');
var CompanyProfiles = require('../../data/CompanyProfiles.json');

var Companies = (_dec = (0, _reactCssModules2.default)(_Companies2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Companies, _Component);

  function Companies(props) {
    (0, _classCallCheck3.default)(this, Companies);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Companies.__proto__ || (0, _getPrototypeOf2.default)(Companies)).call(this, props));

    _this.renderFlags = function (flags) {
      if (flags.length > 0) {
        return _react2.default.createElement(
          'div',
          { styleName: 'flag-box' },
          flags.map(function (flag) {
            var splitName = flag[2].split(' ');
            var shortname = splitName[0];
            shortname = shortname === 'Palm' ? 'Palm oil' : shortname;
            var type = splitName[splitName.length - 1];

            return _react2.default.createElement(
              'span',
              {
                styleName: 'flag ' + (type === 'producer' ? 'flag-p' : 'flag-c'),
                key: flag[0]
              },
              _react2.default.createElement('img', {
                styleName: 'detail-icon-holding',
                src: flag[1],
                alt: flag[2],
                title: flag[2]
              }),
              shortname
            );
          })
        );
      } else {
        return null;
      }
    };

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(Companies, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // images
      var producersIcon = require('../../../static/images/icn-producers.svg');
      var consumersIcon = require('../../../static/images/icn-consumers.svg');
      var iconPo = require('../../../static/images/icn-po.svg');
      var iconPp = require('../../../static/images/icn-pp.svg');
      var iconRb = require('../../../static/images/icn-rb.svg');
      var iconTb = require('../../../static/images/icn-tb.svg');
      var iconBf = require('../../../static/images/icn-bf.svg');
      var iconSy = require('../../../static/images/icn-sy.svg');
      var iconPoY = require('../../../static/images/icn-po-y.svg');
      var iconPpY = require('../../../static/images/icn-pp-y.svg');
      var iconRbY = require('../../../static/images/icn-rb-y.svg');
      var iconTbY = require('../../../static/images/icn-tb-y.svg');
      var iconBfY = require('../../../static/images/icn-bf-y.svg');
      var iconSyY = require('../../../static/images/icn-sy-y.svg');

      var title = 'Companies';
      var url = _config2.default.domain + _config2.default.routes.companies;
      var orderedCompanyIds = ['0C00000AEB', '0C00000726', '0C00000XVP', '0C000017L0', '0C00000CS9', '0C00009CZO', '0C00008Q21', '0C00000XC7', '0C00000Y8G', '0C00000BJN', '0C00000FU1', '0C000008JP', '0C00000GSL', '0C00003APU', '0C000009EB', '0C00000BB5', '0C000008A4', '0C00000BRK', '0C00000C6W', '0C000008LL', '0C00000CI7', '0C000009L0'];
      var entries = CompanyProfiles.data;

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, '', url),
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(_components.DeforestationSectors, null),
          _react2.default.createElement(
            'div',
            { styleName: 'container' },
            _react2.default.createElement(
              'div',
              { styleName: 'container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'profiles-title' },
                'Company profiles'
              ),
              /* display the profile for each company, in order */
              orderedCompanyIds.map(function (cid, idx) {
                var entry = entries[cid];
                var shortName = entry[0];
                var profile = entry[1];
                var pflags = [];
                var cflags = [];
                var c = CompanySectors.data[cid];
                if ((0, _lodash.includes)(c, 'is_po_p')) {
                  pflags.push(['is_po_p', iconPo, 'Palm oil producer']);
                }
                if ((0, _lodash.includes)(c, 'is_pp_p')) {
                  pflags.push(['is_pp_p', iconPp, 'Paper/pulp producer']);
                }
                if ((0, _lodash.includes)(c, 'is_rb_p')) {
                  pflags.push(['is_rb_p', iconRb, 'Rubber producer']);
                }
                if ((0, _lodash.includes)(c, 'is_tb_p')) {
                  pflags.push(['is_tb_p', iconTb, 'Timber producer']);
                }
                if ((0, _lodash.includes)(c, 'is_bf_p')) {
                  pflags.push(['is_bf_p', iconBf, 'Cattle producer']);
                }
                if ((0, _lodash.includes)(c, 'is_sy_p')) {
                  pflags.push(['is_sy_p', iconSy, 'Soy producer']);
                }

                if ((0, _lodash.includes)(c, 'is_po_c')) {
                  cflags.push(['is_po_c', iconPoY, 'Palm oil major consumer brand']);
                }
                if ((0, _lodash.includes)(c, 'is_pp_c')) {
                  cflags.push(['is_pp_c', iconPpY, 'Paper/pulp major consumer brand']);
                }
                if ((0, _lodash.includes)(c, 'is_rb_c')) {
                  cflags.push(['is_rb_c', iconRbY, 'Rubber major consumer brand']);
                }
                if ((0, _lodash.includes)(c, 'is_tb_c')) {
                  cflags.push(['is_tb_c', iconTbY, 'Timber major consumer brand']);
                }
                if ((0, _lodash.includes)(c, 'is_bf_c')) {
                  cflags.push(['is_bf_c', iconBfY, 'Cattle major consumer brand']);
                }
                if ((0, _lodash.includes)(c, 'is_sy_c')) {
                  cflags.push(['is_sy_c', iconSyY, 'Soy major consumer brand']);
                }

                var is_p = pflags.length > 0;
                var is_c = cflags.length > 0;

                var links = CompanyLinks.data[cid];
                var zsl_spott = links ? links.zsl_spott : '';
                var supply_change = links ? links.supply_change : '';
                var banktrack = links ? links.banktrack : '';
                var rspo = links ? links.rspo : '';
                var forest500 = links ? links.forest500 : '';
                var other_link = links ? links.other_link : '';
                var link_map = [[zsl_spott, 'ZSL SPOTT'], [supply_change, 'Supply Change'], [banktrack, 'BankTrack'], [rspo, 'RSPO'], [forest500, 'Forest500'], [other_link, 'Other']];

                var has_links = zsl_spott || supply_change || banktrack || rspo || forest500 || other_link;

                var safeName = shortName.replace('é', 'e');

                var hasLogo = false;
                var companyLogo = null;
                try {
                  companyLogo = require('../../../static/images/companies/' + cid + '.png');
                  hasLogo = true;
                } catch (e) {
                  console.log('');
                }

                return _react2.default.createElement(
                  'div',
                  { key: 'ordered_profile_' + idx },
                  _react2.default.createElement('div', { styleName: 'company-anchor', id: safeName }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'family-modal' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'family-modal-header-wrap' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'family-modal-header' },
                        shortName
                      ),
                      hasLogo ? _react2.default.createElement('img', {
                        styleName: 'company-logo-img',
                        src: companyLogo,
                        alt: shortName
                      }) : null
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'family-modal-p' },
                      profile
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'modal-icons-wrap' },
                      is_p ? _react2.default.createElement(
                        'div',
                        { styleName: 'icons-wrap' },
                        _react2.default.createElement(
                          'div',
                          { styleName: 'sector-headline-wrap' },
                          _react2.default.createElement('img', {
                            styleName: 'sector-icon',
                            src: producersIcon,
                            alt: 'Agricultural commodity producer/trader'
                          }),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'sector-headline-p' },
                            'Agricultural commodity producer/trader'
                          )
                        ),
                        _this2.renderFlags(pflags)
                      ) : null,
                      is_c ? _react2.default.createElement(
                        'div',
                        { styleName: 'icons-wrap' },
                        _react2.default.createElement(
                          'div',
                          { styleName: 'sector-headline-wrap' },
                          _react2.default.createElement('img', {
                            styleName: 'sector-icon',
                            src: consumersIcon,
                            alt: 'Major consumer brands'
                          }),
                          _react2.default.createElement(
                            'div',
                            { styleName: 'sector-headline-c' },
                            'Major consumer brand'
                          )
                        ),
                        _this2.renderFlags(cflags)
                      ) : null
                    ),
                    /* if the company has any research links...  */
                    has_links ? _react2.default.createElement(
                      'div',
                      { styleName: 'links-box' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'links-headline' },
                        'Source information:'
                      ),
                      /* ..display links for the company  */
                      link_map.map(function (e, i) {
                        var has_link = e[0].length;
                        if (has_link) {
                          return _react2.default.createElement(
                            'div',
                            { key: i, styleName: 'research-link-div' },
                            _react2.default.createElement(
                              _components.Link,
                              {
                                to: e[0],
                                title: e[1],
                                xstrong: true
                              },
                              e[1],
                              _react2.default.createElement(_components.LinkIcon, null)
                            )
                          );
                        } else {
                          return null;
                        }
                      })
                    ) : null
                  )
                );
              })
            )
          ),
          _react2.default.createElement(_components.GetStartedInput, null)
        )
      );
    }
  }]);
  return Companies;
}(_react.Component)) || _class);
exports.default = Companies;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Companies/Companies.js
// module id = 1317
// module chunks = 0